import React, { useCallback } from 'react';
import { Flex, Box, FormLabel, Tooltip } from '@chakra-ui/react';
import { ChromePicker } from 'react-color';
import { cssVariables, selectCssVariables } from '../../../redux/cssVariablesSlice';
import { useDispatch, useSelector } from 'react-redux';
import generateCSSGlobalVariables from '../../../utils/cssGlobalVariables';
import _ from 'lodash';

const CssEditorColorPicker = ({ varName }) => {
	const cssVar = useSelector(cssVariables);
	const [closeTimeout, setCloseTimeout] = React.useState(null);
	const [showColorPicker, setShowColorPicker] = React.useState(null);

	function filterColors(variable, varName) {
		if (variable.startsWith(varName.replace('-pure', '')) && varName != variable) return true;

		return false;
	}
	function handleMouseEnter() {
		if (closeTimeout && typeof closeTimeout === 'number') {
			clearTimeout(closeTimeout);
			setCloseTimeout(null);
		}
	}

	function handleMouseLeave() {
		if (closeTimeout) clearTimeout(closeTimeout);
		const timeout = setTimeout(() => {
			setShowColorPicker(false);
		}, 500);
		setCloseTimeout(timeout);
	}

	return (
		<Box onMouseLeave={(e) => handleMouseLeave()} onMouseEnter={(e) => handleMouseEnter()} pb={3}>
			<FormLabel
				mr={0}
				borderColor={'gray.200'}
				fontFamily={'Poppins'}
				color={'gray.700'}
				fontWeight="bold"
				fontSize={'sm'}
			>
				{varName}
			</FormLabel>
			<Flex sx={{ gap: '8px' }} placeItems={'center'} position={'relative'}>
				<PickerContainer {...{ showColorPicker, setShowColorPicker, varName }} />
				{Object.keys(cssVar)
					.filter((variable) => filterColors(variable, varName))
					.map((variable, index) => {
						return (
							<Tooltip key={'tt-cssEditorColorPicker-' + index} label={variable}>
								<Box bg={`var(${variable})`} w={'25px'} h={'25px'} borderRadius={'100%'} />
							</Tooltip>
						);
					})}
			</Flex>
		</Box>
	);
};

const PickerContainer = ({ showColorPicker, setShowColorPicker, varName }) => {
	const cssVar = useSelector(cssVariables);
	const [selectedColor, setSelectedColor] = React.useState(null);

	const debounceUpdateCss = useCallback(_.debounce(changeCss, 1000), [varName, cssVar]);

	function changeColor(value) {
		const { hex } = value;
		setSelectedColor(hex);
	}
	const dispatch = useDispatch();

	function changeCss(value) {
		const { hex } = value;
		const newCssGlobalVar = JSON.parse(JSON.stringify({ ...cssVar }));
		newCssGlobalVar[varName] = hex;
		dispatch(selectCssVariables(generateCSSGlobalVariables(newCssGlobalVar)));
	}
	return (
		<>
			<Box
				onClick={(e) => setShowColorPicker(!showColorPicker)}
				bg={selectedColor ?? `var(${varName})`}
				w={'30px'}
				h={'30px'}
				borderRadius={'100%'}
				border={'1px solid black'}
				_hover={{ cursor: 'pointer' }}
			/>
			{showColorPicker && (
				<Box zIndex={2} position={'absolute'} left={'35px'} top={'35px'}>
					<ChromePicker
						color={selectedColor || cssVar[varName]}
						onChange={changeColor}
						onChangeComplete={debounceUpdateCss}
					/>
				</Box>
			)}
		</>
	);
};
export default CssEditorColorPicker;
